import { Route } from '@angular/router';

export const SemaphoreRoute: Route = {
  path: 'semaphore',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/semaphore_shell'
    ).then((c) => c.semaphoreShellRoutes);
  },
};
